<template>
<v-container>
  <v-card dark tile calss='elevation-10' >
    <v-card-title class='subtitle-1 overline' >
      <v-icon color='amber' class='mr-1' >mdi-star-shooting</v-icon>
      Brand overview
      <v-spacer/>
    </v-card-title>
    <v-divider/>
    <v-tabs v-model='activeTab' >
      <v-tab
        v-for='space in spacesIOwn' :key='space.id'
        :to='`/brand/${space.id}`' >{{ space.title }}</v-tab>
    </v-tabs>
    <v-card-text v-if='!spaceId' >
      Please choose a space to view it's brand
    </v-card-text>
  </v-card>

  <template v-if='spaceId && space && space.id' >
    <v-card class='mt-4 elevation-10'>
      <v-card-title class='subtitle-1 overline' >
        {{spaceName}}
        <v-spacer />
        <v-btn text small
          v-for='section in sections'
          :key='`btn-${section.title}`'
          :outlined='section.id === selectedSection.id'
          @click='setSection(section)'
          v-text='section.shorttitle' />
      </v-card-title>
      <component
        v-if='selectedSection.component'
        :is='selectedSection.component'
        :space-id='spaceId'
        v-model='space'
        v-bind='selectedSection.attrs'
        v-on='$listeners' />
    </v-card>

    <!-- <component
          v-if='section.component'
          :is='section.component'
          :space-id='spaceId'
          :members='members'
          v-bind='section.attrs'
          v-on='$listeners' /> -->
    <!-- <template v-for='section in sections' >
      <a :id="section.id" :name='section.id' :key="`anchor-${section.id}`" ></a>
      <v-card class='mt-4 elevation-10' :key='section.title' >
        <component
          v-if='section.component'
          :is='section.component'
          :space-id='spaceId'
          :members='members'
          v-bind='section.attrs'
          v-on='$listeners' />
      </v-card>
    </template> -->

    <!-- <v-card class='mt-4 elevation-10'>
      <v-card-title class='subtitle-1 overline' >
        Raw:
      </v-card-title>
      <pre class='mx-3' v-text='spaces' />
    </v-card> -->
  </template>
</v-container>
</template>
<script>
import SpaceCard from '@/components/cards/SpaceCard'
// import qr from './qr.vue'
import Sites from './digitalassets/Sites.vue'
import BookingWidgetEmbed from './digitalassets/BookingWidget.vue'
import AppointmentPreview from './digitalassets/AppointmentPreview.vue'
import Printables from './digitalassets/Printables.vue'
// import Notifications from './notifications.vue'
import Invoices from './invoices.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'BrandOverview',
  props: {
    spaceId: { required: false }
  },
  data () {
    return {
      activeTab: 0,
      requests: {
        spaces: {
          resource: 'ag.spaces.practitioner',
          loading: false,
          status: 0,
          result: {}
        }
      },
      selectedSection: null
    }
  },
  mounted () {
    this.selectedSection = this.sections[0]
    this.get()
  },
  methods: {
    setSection (section) {
      this.selectedSection = section
    },
    get () {
      this.$request('get', this.requests.spaces)
    }
  },
  watch: {
    spaceId: {
      immediate: true,
      handler () {
        if (this.spaceId) {
          if (this.spacesList) {
            let index = this.spacesList.findIndex((space) => {
              return parseInt(this.spaceId) === parseInt(space.id)
            })
            if (this.index) {
              this.activeTab = index
            }
          }
          this.get()
        }
      }
    }
  },
  computed: {
    ...mapGetters('identity', ['getMembers', 'spacesIOwn']),
    space () {
      return this.spaces.find ((space) => {
        return parseInt(this.spaceId) === parseInt(space.id)
      })
    },
    spaces () {
      let spaces = this.getObjectPath(this.requests.spaces, 'result.results', [])
      if (this.showArchived === true) {
        return spaces
      } else {
        return spaces.filter((space) => { return space.archived === false })
      }
    },
    members () {
      return this.getMembers(this.spaceId)
    },
    sections () {
      return [
        {
          id: 'overview',
          title: 'Overview',
          shorttitle: 'Overview',
          component: SpaceCard
        },
        {
          id: 'invoices',
          title: 'Invoices',
          shorttitle: 'Invoices',
          component: Invoices
        },
        {
          id: 'sites',
          title: 'Websites',
          shorttitle: 'Webpages',
          component: Sites,
          attrs: {
            profile: this.profile
          }
        },
        {
          id: 'online-bookings',
          title: 'Booking Pages',
          shorttitle: 'Booking Pages',
          component: BookingWidgetEmbed
        },
        {
          id: 'appointment-page',
          title: 'Appointment Page',
          shorttitle: 'Appointment Page',
          component: AppointmentPreview
        },
        {
          id: 'printables',
          title: 'Printables',
          shorttitle: 'Printables',
          component: Printables,
          attrs: {
            members: this.members
          }
        },
        // {
        //   id: 'notifications',
        //   title: 'Notifications and communications',
        //   shorttitle: 'Notifications',
        //   component: Notifications
        // },
        // {
        //   id: 'qr',
        //   title: 'QR codes',
        //   shorttitle: 'QR codes',
        //   component: qr
        // }
      ]
    }
  }
}
</script>
